export const UPDATE_OPTIONS = "UPDATE_OPTIONS";
export const UPDATE_VIEW_TYPE = "UPDATE_VIEW_TYPE";
export const UPDATE_DATE_TYPE = "UPDATE_DATE_TYPE";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const REMOVE_COLUMN = "REMOVE_COLUMN";
export const ADDED_COLUMN = "ADDED_COLUMN";
export const RESET_REPO_AND_PREFS = "RESET_REPO_AND_PREFS";
